import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import { withQuery } from '../../../../hoc/withGraphql';
import Loader from '../../../../components/Loader/Loader'
import s from './EditReviewsWhyHost.css';
import WhyHostFormBlock5 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock5/WhyHostFormBlock5'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';

class EditReviewsWhyHost extends React.Component {

    static defaultProps = {
        data: {
            loading: false
        }
    };

    render() {
        const { data: { loading, getWhyHostReview }, reviewId } = this.props;
        if (loading) {
            return <Loader type={"text"} />;
        } else {
            return <WhyHostFormBlock5 initialValues={getWhyHostReview && getWhyHostReview.result} reviewId={reviewId} />
        }
    }
}

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: (props) => ({
            variables: {
                reviewId: props.reviewId,
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
)(EditReviewsWhyHost);